import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
  Paper,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import {
  HeroSection,
  HeroTitle,
  HeroSubtitle,
} from "../../../components/hero-section/HeroSection";

const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius * 1.5,
  backgroundColor: "#fff",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(3),
  },
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  boxShadow: "none",
  "&:before": {
    display: "none",
  },
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius}px !important`,
  "&.Mui-expanded": {
    margin: `0 0 ${theme.spacing(2)}`,
  },
  "& .MuiAccordionSummary-root": {
    padding: theme.spacing(2, 3),
  },
  "& .MuiAccordionDetails-root": {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

const FAQs = () => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ps' || i18n.language === 'dr';
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs = [
    {
      question: t('help.faqs.questions.bookTypes'),
      answer: t('help.faqs.answers.bookTypes'),
    },
    {
      question: t('help.faqs.questions.access'),
      answer: t('help.faqs.answers.access'),
    },
    {
      question: t('help.faqs.questions.payment'),
      answer: t('help.faqs.answers.payment'),
    },
    {
      question: t('help.faqs.questions.offline'),
      answer: t('help.faqs.answers.offline'),
    },
    {
      question: t('help.faqs.questions.refund'),
      answer: t('help.faqs.answers.refund'),
    },
    {
      question: t('help.faqs.questions.sharing'),
      answer: t('help.faqs.answers.sharing'),
    },
    {
      question: t('help.faqs.questions.bulk'),
      answer: t('help.faqs.answers.bulk'),
    },
    {
      question: t('help.faqs.questions.support'),
      answer: t('help.faqs.answers.support'),
    },
    {
      question: t('help.faqs.questions.security'),
      answer: t('help.faqs.answers.security'),
    },
    {
      question: t('help.faqs.questions.devices'),
      answer: t('help.faqs.answers.devices'),
    },
  ];

  return (
    <Box>
      <HeroSection>
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8}>
              <HeroTitle>{t('help.faqs.title')}</HeroTitle>
              <HeroSubtitle>
                {t('help.faqs.subtitle')}
              </HeroSubtitle>
            </Grid>
          </Grid>
        </Container>
      </HeroSection>

      <Box sx={{ py: 6, backgroundColor: "background.default" }}>
        <Container maxWidth="lg">
          <ContentPaper elevation={0}>
            {faqs.map((faq, index) => (
              <StyledAccordion
                key={index}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index}d-content`}
                  id={`panel${index}d-header`}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" color="text.secondary">
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </StyledAccordion>
            ))}
          </ContentPaper>
        </Container>
      </Box>
    </Box>
  );
};

export default FAQs;
